import { AfterViewInit, Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { CommonService } from 'src/app/services/common.service';
import { MatSelect } from '@angular/material/select';
import { MatOption } from '@angular/material/core';

@Component({
  selector: 'app-dropdown-multiselect',
  templateUrl: './dropdown-multiselect.component.html',
  styleUrls: ['./dropdown-multiselect.component.css']
})
export class DropdownMultiselectComponent implements OnInit, AfterViewInit {
  @Input() labelText: string = "";
  @Input() lstDropdownOption: any = [];
  @Input() allSelected: boolean = true;
  @Input() isMultiSelect: boolean = true;
  @Input() is_has_default_value: boolean = false;
  @Input() isMandetory:number=0;

  @Input() selectedValues: any = [];
  @Input() selectedText: any = [];
  @ViewChild('dropdownMultiSelect') dropdownMultiSelect: MatSelect;
  @Output() Raise_event_selection_changed = new EventEmitter<any>();

  constructor(private commonService: CommonService) {
  }

  ngOnInit(): void {
    if (!this.is_has_default_value) {
      this.selectedText = [];
      this.selectedValues = [];
    }
    else {
      // setTimeout(() => {
      //   this.onDropdownOptionClick();
      // }, 2000);
    }

  }
  ngAfterViewInit() {
    setTimeout(() => {
      if (this.allSelected) {
        this.selectedText = [];
        this.selectedValues = [];
        this.dropdownMultiSelect.options.forEach((item: MatOption) => item.select());
        this.dropdownMultiSelect.options.forEach((item: MatOption) => {
          if (item.selected) {
            this.selectedValues.push(item.value);
            this.selectedText.push(item.viewValue);
          }
        });
      }
    }, 2000);
  }

  toggleAllOptoinSelection() {
    if (this.allSelected) {
      this.dropdownMultiSelect.options.forEach((item: MatOption) => item.select());
    } else {
      this.dropdownMultiSelect.options.forEach((item: MatOption) => item.deselect());
    }
    this.onDropdownOptionClick();
  }
  onDropdownOptionClick() {
    let newStatus = true;
    this.selectedValues = [];
    this.selectedText = [];
    this.dropdownMultiSelect.options.forEach((item: MatOption) => {
      if (!item.selected) {
        newStatus = false;
      } else {
        this.selectedValues.push(item.value);
        this.selectedText.push(item.viewValue);
      }
    });
    this.allSelected = newStatus;
    this.onSelectionChanged();
  }

  onSelectionChanged() {
    this.Raise_event_selection_changed.emit({ selectedValues: this.selectedValues, selectedText: this.selectedText });
  }
}
